import '../assets/sass/web/_homeloancalculator.scss'
import {isSet,isEmpty,getterSetter,isValidEmail,source} from './utils/common'
import {getLoggedInUser} from './loginService'
import {otpService} from './services/otpService'
import countries from './nri/country_code';
import {generateOTP,submitReply,verifyOTP,showOtpSuccessSection} from './reply/replyservices'
import {getCookie} from './services/cookieService'
import {login} from './loginService';
import constants from './cityConstant.js';
import countryAndState from './countryAndStateConstant.js';
import citiesByState from './citiesByState.js';
import {drawPieChart} from './pieChartService'
import {addApplicants, removeApplicants, validateCoApplicants} from './coApplicantsService'
import * as EmiCalc from "./homeloanEmiCalculator";
import * as PrepaymentCalc from "./homeloanPrepaymentCalc";
import * as RateChangeCalc from "./homeloanRateChangeCalc";
import * as LoanTransferCalc from "./homeloanTransferCalc";
import * as RepaymentCalc from "./homeloanMonthlyRepaymentCalc";
import {Datepicker} from './utils/datepicker'

require('./controller/citySelectController.js')
require('./controller/header.js')
const initialState = {
    cities: [
        ...citiesByState.stateCities,
    ],
    countryNames: [
    	...countryAndState.data.topCountries,
    ],
    states: [
    	...countryAndState.data.topStates,
    ]
};


window.HomeLoanCalculator = {
	init: () => {
        HomeLoanCalculator.checkLogin();
		HomeLoanCalculator.initializeCitySuggest();
		HomeLoanCalculator.initializeOccupation();
		HomeLoanCalculator.initializeLoantype();
		homeloancalc.inputValues = {};
		homeloancalc.coapplicants = [];

        homeloancalc.suggestNavIdx =  -1;
        homeloancalc.elSuggestNavLast = null;
        homeloancalc.elSuggestions = null;

        homeloancalc.emiCalculator = {};
        homeloancalc.prepaymentCalc = {};
        homeloancalc.rateChangeCalc = {};
        homeloancalc.loanTransferCalc = {};
        homeloancalc.mrepaymentCalc = {};
	},
    checkLogin: () => {
        //Get LoggedIn User details...
        getLoggedInUser.then((result) => {
            if(result && result.data && result.data.user) {
                HomeLoanCalculator.setHlcalcUserDetails(result);
            } else {
                getterSetter.set('loginstatus', false);
            }
        });
    },
    setHlcalcUserDetails: (result) => {
        getterSetter.set( 'loginData', result);
        getterSetter.set( 'loginstatus', true);

        let username = '';
        if(isSet(result.data.user) && isSet(result.data.user.firstName)) {
            username =  result.data.user.firstName;
            if(isSet(result.data.user.lastName)) {
                username += ' ' + result.data.user.lastName;
            }
        }
        document.getElementById('username').value = username;
        document.getElementById('useremail').value = result.data.user.userEmail.length > 0 ? result.data.user.userEmail[0].emailId : '';
        if(!isSet(postAdTree.AdOutline.user_mobile)) {
            document.getElementById('usermobile').value = result.data.user.userMobile.length > 0 ? result.data.user.userMobile[0].mobileNumber : '';
        }
        document.getElementById('checkEligibility').classList.remove('opacity_otp');
         
    },
    initializeCitySuggest: () => {
    	initialState.countyCodes = initialState.countryNames.map((country) => +country.code);
        initialState.stateCodes = initialState.states.map((states) => +states.code);
        initialState.cityIds = initialState.cities.map((city) => +city.id);
        
        // Render the Residential countries as default
        HomeLoanCalculator.renderResTopCountries(false);
       
        // Render the Residential states as default
        HomeLoanCalculator.renderResStates(false);

        // Render the Property Located states as default
        HomeLoanCalculator.renderPropLocatedStates(false);

        HomeLoanCalculator.renderCountryCodeSuggestions(countries);

        // Attach the event handlers for country code suggestions
        document.getElementById('countryCodeSearch').addEventListener('input', HomeLoanCalculator.handleCountryCodeSearch);
        //document.getElementById('countryCodeSearch').addEventListener('keydown', HomeLoanCalculator.handleCountrySuggestionNavigation);
        document.getElementById('countryCodeSuggestions').addEventListener('click', HomeLoanCalculator.handleCountryCodeSelection);

        // Attach the event handlers for country suggestions
        document.getElementById('resCountrySearch').addEventListener('input', HomeLoanCalculator.handleResCountrySearch);
        document.getElementById('resCountrySearch').addEventListener('blur', HomeLoanCalculator.handleResCountrySearchFocusOut);
        //document.getElementById('resCountrySearch').addEventListener('keydown', HomeLoanCalculator.handleCountrySuggestionNavigation);
        document.getElementById('resCountrySearchUl').addEventListener('click', HomeLoanCalculator.handleResCountrySelection);

        // Attach the event handlers for state suggestions
        document.getElementById('resStateSearch').addEventListener('input', HomeLoanCalculator.handleResStateSearch);
        document.getElementById('resStateSearch').addEventListener('blur', HomeLoanCalculator.handleResStateSearchFocusOut);
        //document.getElementById('resStateSearch').addEventListener('keydown', HomeLoanCalculator.handleStateSuggestionNavigation);
        document.getElementById('resStateSearchUl').addEventListener('click', HomeLoanCalculator.handleResStateSelection);

        // Attach the event handlers for city suggestions
        document.getElementById('resCitySearch').addEventListener('input', HomeLoanCalculator.handleResCitySearch);
        document.getElementById('resCitySearch').addEventListener('blur', HomeLoanCalculator.handleCitySearchFocusOut);
        //document.getElementById('resCitySearch').addEventListener('keydown', HomeLoanCalculator.handleCitySuggestionNavigation);
        document.getElementById('resCitySearchUl').addEventListener('click', HomeLoanCalculator.handleCitySelection);

        // Attach the event handlers for property located city suggestions
        document.getElementById('propLocatedCitySearch').addEventListener('input', HomeLoanCalculator.handlePropLocatedCitySearch);
        document.getElementById('propLocatedCitySearch').addEventListener('blur', HomeLoanCalculator.handlePropLocatedCitySearchFocusOut);
        //document.getElementById('resCitySearch').addEventListener('keydown', HomeLoanCalculator.handleCitySuggestionNavigation);
        document.getElementById('propLocatedCitySearchUl').addEventListener('click', HomeLoanCalculator.handlePropLocatedCitySelection);

        // Attach the event handlers for property located state suggestions
        document.getElementById('propLocatedStateSearch').addEventListener('input', HomeLoanCalculator.handlePropLocatedStateSearch);
        document.getElementById('propLocatedStateSearch').addEventListener('blur', HomeLoanCalculator.handlePropLocatedStateSearchFocusOut);
        //document.getElementById('resCitySearch').addEventListener('keydown', HomeLoanCalculator.handleCitySuggestionNavigation);
        document.getElementById('propLocatedStateSearchUl').addEventListener('click', HomeLoanCalculator.handlePropLocatedStateSelection);
    },
    handleCountryCodeSearch({target: {value}}) {
        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Filter by matching the phone codes or the name itself
        const matchingCountyCodes = countries.filter((country) => 
            country.dial_code.includes(value) || country.name.toLowerCase().startsWith(value));

        // Render the matching countries
        HomeLoanCalculator.renderCountryCodeSuggestions(matchingCountyCodes);
    },
    renderCountryCodeSuggestions(countries = []) {
        document.getElementById('countryCodeSuggestions').innerHTML = countries.reduce((html, country) => html + `
            <li tabindex="-1" data-value="${country.dial_code}" data-country="${country.code}">${country.dial_code} (${country.name})</li>
        `, '');
    },
    handleCountryCodeSelection({target: {dataset: {value, country}}}) {
        if (!value || !country) return;

        // Store the selected 
        document.getElementById('hiddenPhoneCode').value = value;
        document.getElementById('hiddenCountryCode').value = country;
        document.getElementById('labelPhoneCode').innerHTML = value;

        // Hide the OTP field and reset the OTP state
        //this.clearAndHideOtpField();
    },
    renderResStates: (inflate = true) => {
        HomeLoanCalculator.renderResStateSuggestions(countryAndState.data.topStates, inflate);
    },
    renderResStateSuggestions: (states = [], inflate = true) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('resStateSearch').parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('resStateSearchUl').innerHTML = states.reduce((html, state) => html + `
            <li data-value="${state.code}">${(state.name).toLowerCase()}</li>
        `, '');
    },
    handleResStateSearch: ({target: {value}}) => {
        // Reset the selected state hidden field
        document.getElementById('hiddenResStateId').value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            this.renderResStates();
        } else {
            // Search for the city by name based on the search string
            const matchingStates = initialState.states
                .filter((state) => state.name.toLowerCase().startsWith(value));

            // Render the matching states
            HomeLoanCalculator.renderResStateSuggestions(matchingStates);
        }
    },
    handleResStateSearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('resStateSearch').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handleResStateSelection: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }
        // Store the selected state id a hidden field
        document.getElementById('hiddenResStateId').value = value;
        document.getElementById('resStateSearch').value = textContent;
        document.getElementById('resStateSearch').focus();
        HomeLoanCalculator.renderResCitySuggestions(citiesByState.stateCities[value], true);
    },
    renderResTopCountries: (inflate = true) => {
        HomeLoanCalculator.renderResCountrySuggestions(countryAndState.data.topCountries, inflate);
    },
    renderResCountrySuggestions: (countryNames = [], inflate = true) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('resCountrySearch').parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('resCountrySearchUl').innerHTML = countryNames.reduce((html, country) => html + `
            <li data-value="${country.code}">${(country.name).toLowerCase()}</li>
        `, '');
    },
    handleResCountrySearch: ({target: {value}}) => {
        // Reset the selected country hidden field
        document.getElementById('hiddenResCountryId').value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            this.renderResTopCountries();
        } else {
            // Search for the city by name based on the search string
            const matchingCountries = initialState.countryNames
                .filter((country) => country.name.toLowerCase().startsWith(value));

            // Render the matching countryNames
            HomeLoanCalculator.renderResCountrySuggestions(matchingCountries);
        }
    },
    handleResCountrySearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('resCountrySearch').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handleResCountrySelection: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }
        // Store the selected city id a hidden field
        document.getElementById('hiddenResCountryId').value = value;
        document.getElementById('resCountrySearch').value = textContent;
        document.getElementById('resCountrySearch').focus();
    },
    renderResCitySuggestions: (cities = [], inflate = true) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('resCitySearch').parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('resCitySearchUl').innerHTML = cities.reduce((html, city) => html + `
            <li data-value="${city.id}">${city.name}</li>
        `, '');
    },
    handleResCitySearch: ({target: {value}}) => {
        // Reset the selected city hidden field
        document.getElementById('hiddenResCityId').value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            //this.renderResTopCities();
        } else {
            // Search for the city by name based on the search string
           let stateCode = document.getElementById('hiddenResStateId').value;
            const matchingCities = citiesByState.stateCities[stateCode]
                .filter((city) => city.name.toLowerCase().startsWith(value));

            // Render the matching cities
            HomeLoanCalculator.renderResCitySuggestions(matchingCities);
        }
    },
    handleCitySearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('resCitySearch').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handleCitySelection: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }
        // Store the selected city id a hidden field
        document.getElementById('hiddenResCityId').value = value;
        document.getElementById('resCitySearch').value = textContent;
        document.getElementById('resCitySearch').focus();
    },
    renderPropLocatedCitySuggestions: (cities = [], inflate = true) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('propLocatedCitySearch').parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('propLocatedCitySearchUl').innerHTML = cities.reduce((html, city) => html + `
            <li data-value="${city.id}">${city.name}</li>
        `, '');
    },
    handlePropLocatedCitySearch: ({target: {value}}) => {
        // Reset the selected city hidden field
        document.getElementById('hiddenPropLocatedCityId').value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            //this.renderPropLocatedTopCities();
        } else {
            // Search for the city by name based on the search string
            let stateCode = document.getElementById('hiddenPropLocatedStateId').value;
            const matchingCities = citiesByState.stateCities[stateCode]
                .filter((city) => city.name.toLowerCase().startsWith(value));

            // Render the matching cities
            HomeLoanCalculator.renderPropLocatedCitySuggestions(matchingCities);
        }
    },
    handlePropLocatedCitySearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('propLocatedCitySearch').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handlePropLocatedCitySelection: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }
        // Store the selected city id a hidden field
        document.getElementById('hiddenPropLocatedCityId').value = value;
        document.getElementById('propLocatedCitySearch').value = textContent;
        document.getElementById('propLocatedCitySearch').focus();
    },
    renderPropLocatedStates: (inflate = true) => {
        HomeLoanCalculator.renderPropLocatedStateSuggestions(countryAndState.data.topStates, inflate);
    },
    renderPropLocatedStateSuggestions: (states = [], inflate = true) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('propLocatedStateSearch').parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('propLocatedStateSearchUl').innerHTML = states.reduce((html, state) => html + `
            <li data-value="${state.code}">${(state.name).toLowerCase()}</li>
        `, '');
    },
    handlePropLocatedStateSearch: ({target: {value}}) => {
        // Reset the selected state hidden field
        document.getElementById('hiddenPropLocatedStateId').value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            this.renderPropLocatedStates();
        } else {
            // Search for the state by name based on the search string
            const matchingStates = initialState.states
                .filter((state) => state.name.toLowerCase().startsWith(value));

            // Render the matching states
            HomeLoanCalculator.renderPropLocatedStateSuggestions(matchingStates);
        }
    },
    handlePropLocatedStateSearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('propLocatedStateSearch').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handlePropLocatedStateSelection: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }
        // Store the selected state id in a hidden field
        document.getElementById('hiddenPropLocatedStateId').value = value;
        document.getElementById('propLocatedStateSearch').value = textContent;
        document.getElementById('propLocatedStateSearch').focus();
        HomeLoanCalculator.renderPropLocatedCitySuggestions(citiesByState.stateCities[value], true);
    },
    initializeOccupation: () => {

        document.getElementById('occupation').addEventListener('click', HomeLoanCalculator.handleOccupationSelection);
    },
    handleOccupationSelection: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }  
        // Store the selected city id a hidden field
        document.getElementById('hiddenOccupation').value = value;
        document.getElementById('select_occupation').innerHTML = '<span>' + textContent + '</span>';
        if(textContent == 'Employed'){
        	document.getElementById('totalMonthlyEmi').classList.remove('opacity_otp');
        	document.getElementById('retiredAge').classList.remove('opacity_otp');
        	document.getElementById('grossMonthlyIncome').classList.remove('opacity_otp');
        }else{
        	document.getElementById('totalMonthlyEmi').classList.add('opacity_otp');
        	document.getElementById('retiredAge').classList.add('opacity_otp');
        	document.getElementById('grossMonthlyIncome').classList.add('opacity_otp');
        	document.getElementById('gross_monthly_income').value = '';
        	document.getElementById('retired_age').value = '';
        	document.getElementById('totalEmi').value = ''
        }
    },
    initializeLoantype: () =>{
    	document.getElementById('loantype').addEventListener('click', HomeLoanCalculator.handleLoanType);
    },
    handleLoanType: ({target: {textContent, dataset: {value}}}) => {
        if (!value) {
            return;
        }  
        // Store the selected loan type id a hidden field
        document.getElementById('hiddenLoantype').value = value;
        document.getElementById('select_loantype').innerHTML = '<span>' + textContent + '</span>';
        if(value == 'HOU'){
        	document.getElementById('propertyShortlisted').classList.remove('opacity_otp');
        }else{
        	document.getElementById('propertyShortlisted').classList.add('opacity_otp');
        }
        let shortlist = document.getElementById('shortlisted').checked;
        if(value == 'HOU' && shortlist == true){
			document.getElementById('propertyLocatedState').classList.remove('opacity_otp');
			document.getElementById('propertyLocatedCity').classList.remove('opacity_otp');
			document.getElementById('costEstimateLabel').innerHTML = 'Property Cost / Estimate';
        }else{
        	if(value == 'IMP'){
        		document.getElementById('costEstimateLabel').innerHTML = 'Improvement Cost / Estimate';
        	}else if(value == 'EXT'){
        		document.getElementById('costEstimateLabel').innerHTML = 'Extension Cost / Estimate';
        	}else{
                document.getElementById('costEstimateLabel').innerHTML = 'Property Cost / Estimate';
            }
        	document.getElementById('propertyLocatedState').classList.add('opacity_otp');
        	HomeLoanCalculator.hideError('hiddenPropLocatedStateId_error');
        	document.getElementById('hiddenPropLocatedStateId').value = '';
        	document.getElementById('propLocatedStateSearch').value = '';
			document.getElementById('propertyLocatedCity').classList.add('opacity_otp');
			HomeLoanCalculator.hideError('hiddenPropLocatedCityId_error');
        	document.getElementById('hiddenPropLocatedCityId').value = '';
        	document.getElementById('propLocatedCitySearch').value = '';
        }
    },
    generateOTP: () => {
        if(HomeLoanCalculator.isMobileValid() && HomeLoanCalculator.isEmailValid() && HomeLoanCalculator.isNameValid()){
			if (homeloancalc.isOtpSent) {
            // Build the OTP generation payload
            const payload = {
                otpId: otpService.getOtpVariable().otpId,
                otpClientId: otpService.getOtpVariable().otpClientId,
                source: source(),
                page: 'REPLY'
            };

            // Trigger resend OTP
            return otpService.resendOTP(payload)
                .then((response) => {
                    // Clear the OTP field
                    //this.refs.otp.value = '';
                    homeloancalc.isOtpEntered = false;

                    if (!('response' in response)) {
                        throw response;
                    }
                    document.getElementById('opacity_otp').classList.remove('opacity_otp');
                    return JSON.parse(response.response).ResendOTPApplicationResponse;
                })
                .then((data) => {
                    // TODO: Show a message that the OTP has been resent
                    homeloancalc.isOtpSent = true;
                    otpService.setOtpVariable(data.ResendOTPApplication.otpId, 'otpId');
                    document.getElementById('sendOtp').classList.add('hide');
                    return data;
                });
        }

        // Build the OTP generation payload
        const payload = {
            email: homeloancalc.inputValues.useremail,
            mobile: homeloancalc.inputValues.usermobile,
            firstName: homeloancalc.inputValues.username,
            source: source(),
            page: 'REPLY'
        };

        // Trigger GA
        //analytics.GA.sendOtpClicked();

        return otpService.generateOTP(payload)
            .then((response) => {
                if (!('response' in response)) {
                    homeloancalc.isOtpSent = false;
                    throw response;
                }
    
                otpService.setOtpVariable(response.clientId, 'otpClientId');
                return JSON.parse(response.response).GenerateOTPApplicationResponse;
            })
            .then((data) => {
                homeloancalc.isOtpSent = true;
                homeloancalc.isOtpEntered = false;
                otpService.setOtpVariable(data.GenerateOTPApplication.otpId, 'otpId');
                document.getElementById('opacity_otp').classList.remove('opacity_otp');
                document.getElementById('sendOtp').innerHTML = 'Resend OTP';
                document.getElementById('otpMsg').innerHTML = '4 digit code sent on ' + document.getElementById('usermobile').value;

                return data;
            });
		}
        
    },
	validateOtp: () => {
		
		let otp = document.getElementById('otp').value;
		if(otp !='' && otp.length == 4) {
			HomeLoanCalculator.hideError('otp_error');
		} else {
			let msg = "Please enter valid OTP";
			HomeLoanCalculator.showError('otp_error', msg);
			return false;
		}
		//otp verify
		HomeLoanCalculator.validateOtpAndLogin();

	},
	validateOtpAndLogin: () => {
		let usermobile = document.getElementById('usermobile').value;
		let username = document.getElementById('username').value;
        const payload = {
            GreetingName: usermobile,
            password: '',
            otpRequest: 1,
            otpNumber : document.getElementById('otp').value,
            otpId: otpService.getOtpVariable().otpId,
            page: 'REPLY',
            source: source()
        };

        return login(payload).then((response) => {
            if (response.error) {
                throw response.data;
            }

            if (response.status == 'AUTH_SUCCESS') {
                if(response && response.data && response.data.user) {
                    getterSetter.set('loginData', response);
                    getterSetter.set('loginstatus', true);
                    getterSetter.set('otpFlag', true);
                    getterSetter.set('userId', response.data.user.id);
                    document.getElementById('checkEligibility').classList.remove('opacity_otp');
                    document.getElementById('sendOtp').classList.add('hide');
                    document.getElementById('tickMark').classList.remove('hide');
                    document.getElementById('opacity_otp').classList.add('opacity_otp');
                    document.getElementById('otp').value = '';
                } else {
                    getterSetter.set('otpFlag', false);
                    getterSetter.set( 'loginstatus', false);
                }

                if ('undefined' !== typeof PUB_SUB) {
                    PUB_SUB.emit('do_login', {name: username});
                }     
            }
        });
    },
    checkResidence: (type) => {
    	if(type == 'indian'){
    		document.getElementById('residentialCity').classList.remove('opacity_otp');
    		document.getElementById('residentialState').classList.remove('opacity_otp');
    		document.getElementById('residentialCountry').classList.add('opacity_otp');
    		HomeLoanCalculator.hideError('hiddenResCountryId_error');
        	document.getElementById('hiddenResCountryId').value = '';
        	document.getElementById('resCountrySearch').value = '';
    	}else if(type == 'nri'){
    		document.getElementById('residentialCountry').classList.remove('opacity_otp');
    		document.getElementById('residentialCity').classList.add('opacity_otp');
    		HomeLoanCalculator.hideError('hiddenResCityId_error');
        	document.getElementById('hiddenResCityId').value = '';
        	document.getElementById('resStateSearch').value = '';
        	document.getElementById('residentialState').classList.add('opacity_otp');
    		HomeLoanCalculator.hideError('hiddenResStateId_error');
        	document.getElementById('hiddenResStateId').value = '';
        	document.getElementById('resCitySearch').value = '';
    	}
    },
    convertCoPrice: (id,val) => {
        HomeLoanCalculator.isNemericCoPriceValue(id,val);
        let price = document.getElementById(id+val).value;
        let rupees = HomeLoanCalculator.indianRupee(price);
        document.getElementById(id+val).value = rupees;
        let data = HomeLoanCalculator.inWords(price);
        document.getElementById(id+val+'_price').innerHTML = data;
    },
    convertPrice: (id) => {
        HomeLoanCalculator.isNemericPriceValue(id);
        let price = document.getElementById(id).value;
        let rupees = HomeLoanCalculator.indianRupee(price);
        document.getElementById(id).value = rupees;
        let data = HomeLoanCalculator.inWords(price);
        document.getElementById(id+'_price').classList.remove('hide');
        document.getElementById(id+'_price').innerHTML = data;
    },
    inWordsOnly: (num) => {
        num = num.replace(/,/g, '');
        let a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
        let b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
        if ((num = num.toString()).length > 4) return '';
        let n = ('0000' + num).substr(-4).match(/^(\d{2})(\d{2})$/);
        if (!n) return; var str = '';
        str += (n[2] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) : '';
        return str;
    },
    inWords: (num) => {
        num = num.replace(/,/g, '');
        let a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
        let b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
        if ((num = num.toString()).length > 9) return 'overflow';
        let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return; var str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'Only ' : '';
        return str;
    },
    indianRupee: (x) => {
        x = x.replace(/,/g, '');
        if (isNaN(x)) {
            return '';
        }
        x=x.toString();
        var lastThree = x.substring(x.length-3);
        var otherNumbers = x.substring(0,x.length-3);
        if(otherNumbers != '')
            lastThree = ',' + lastThree;
        var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return res;
    },
	checkEligibility: () => {
        topnavGAHL('CheckEligibility');
        homeloancalc.coapplicants = [];
		if(HomeLoanCalculator.validateEligibilityForm()){
            let coApplicants = document.getElementById('add_co_applicants').children;
			if(coApplicants.length > 0){
				if(!validateCoApplicants(coApplicants)){
                    return false;
				}
			}
            let hiddenOccupationVal = document.getElementById('hiddenOccupation').value;
            if(coApplicants.length <= 0 && hiddenOccupationVal != 'E'){
                document.getElementById('error_message').innerHTML = 'At least one applicant should be employed.';
                document.getElementById('hc_error_popup').click();
                return false;
            }else if(coApplicants.length > 0 && hiddenOccupationVal != 'E'){
                let employed = false;
                let coApplicantsArr = homeloancalc.coapplicants;
                for (var i = 0; i < coApplicantsArr.length; i++) {
                    if(coApplicantsArr[i].userOccupation == 'E'){
                        employed = true;
                    }
                }
                if(employed == false){
                    document.getElementById('error_message').innerHTML = 'At least one applicant should be employed.';
                    document.getElementById('hc_error_popup').click();
                    return false;
                }
            }
            let loanSalary = false;
            let gross_income = document.getElementById('gross_monthly_income').value;
            gross_income = gross_income.replace(/,/g, '');
            gross_income = parseInt(gross_income);
            let loan_amount = document.getElementById('loan_amount').value;
            loan_amount = loan_amount.replace(/,/g, '');
            loan_amount = parseInt(loan_amount);
            if(coApplicants.length <= 0 && hiddenOccupationVal == 'E'){
                if(gross_income >= loan_amount){
                    loanSalary = true;
                }
            }else if(coApplicants.length > 0 && hiddenOccupationVal == 'E'){
                let totalSalary = gross_income;
                let coApplicantsArr = homeloancalc.coapplicants;
                for (var i = 0; i < coApplicantsArr.length; i++) {
                    if(coApplicantsArr[i].userOccupation == 'E'){
                        totalSalary += parseInt(coApplicantsArr[i].monthlyIncome);
                    }
                }
                if(totalSalary >= loan_amount){
                    loanSalary = true;
                }
            }else if(coApplicants.length > 0 && hiddenOccupationVal != 'E'){
                let totalSalary = '';
                let coApplicantsArr = homeloancalc.coapplicants;
                for (var i = 0; i < coApplicantsArr.length; i++) {
                    if(coApplicantsArr[i].userOccupation == 'E'){
                        totalSalary += parseInt(coApplicantsArr[i].monthlyIncome);
                    }
                }
                if(totalSalary >= loan_amount){
                    loanSalary = true;
                }
            }
            if(loanSalary == true){
                document.getElementById('error_message').innerHTML = 'Your Monthly Salary is more than the Loan Amount. Please try again by changing the values.';
                document.getElementById('hc_error_popup').click();
                return false;
            }
            if(document.getElementById('nri').checked == true){
                let salary = false;
                let gross_income = document.getElementById('gross_monthly_income').value;
                gross_income = gross_income.replace(/,/g, '');
                if(hiddenOccupationVal == 'E' && gross_income < 60000){
                    salary = true;
                }else {
                    let coApplicantsArr = homeloancalc.coapplicants;
                    for (var i = 0; i < coApplicantsArr.length; i++) {
                        if(coApplicantsArr[i].userOccupation == 'E' && coApplicantsArr[i].monthlyIncome < 60000){
                            salary = true;
                        }
                    }
                }
                if(salary == true){
                    document.getElementById('error_message').innerHTML = 'The minimum gross monthly salary should be above &#8377;60 K.';
                    document.getElementById('hc_error_popup').click();
                    return false;
                }
            }
			if(document.getElementById('indian').checked == true){
				homeloancalc.inputValues.residenceStatus = 'RES';
			}else if(document.getElementById('nri').checked == true){
				homeloancalc.inputValues.residenceStatus = 'NRI';
			}
			if(document.getElementById('male').checked == true){
				homeloancalc.inputValues.gender = 'M';
			}else if(document.getElementById('female').checked == true){
				homeloancalc.inputValues.gender = 'F';
			}
            let hiddenLoanType = document.getElementById('hiddenLoantype').value;
            if(hiddenLoanType == 'HOU'){
                if(document.getElementById('shortlisted').checked == true){
                    homeloancalc.inputValues.isPropShortlisted = true;
                }else if(document.getElementById('notShortlisted').checked == true){
                    homeloancalc.inputValues.isPropShortlisted = false;
                }
            }else {
                homeloancalc.inputValues.isPropShortlisted = false;
            }
			
			homeloancalc.inputValues.totalMonthlyEmiPaid = (document.getElementById('totalEmi').value).replace(/,/g, '');
			homeloancalc.inputValues.hiddenPhoneCode = (document.getElementById('hiddenPhoneCode').value).replace('+', '');
			document.getElementById('spinner').classList.remove('hidden');
            //ajax
			$.ajax({
                url: "/homes/re2/homeloanEligibilityCalc?aj=1",
                type: "POST",
                data: {'homeloancalc' : JSON.stringify(homeloancalc)},
                success: function (data) {
                    if(!isEmpty(data)){
                        document.getElementById('spinner').classList.add('hidden');
                        if(data['emi'] <= 0){
                            document.getElementById('error_message').innerHTML = 'Eligibility details are not found. Please try again by changing amount.';
                            document.getElementById('hc_error_popup').click();
                            return false;
                        }
                        document.getElementById('homeloanform').classList.add('hide');
                        document.getElementById('homeloanemi').classList.remove('hide');
                        document.getElementById('principalAmount').innerHTML = data['loanAmount'];
                        document.getElementById('interestAmount').innerHTML = data['interestAmount'];
                        document.getElementById('totalAmountPayable').innerHTML = data['totalPayableAmount'];
                        document.getElementById('emi_per_month').innerHTML = 'EMI &#8377; ' + data['emi'] + ' / Month';
                        
                        drawPieChart(data);
                    }else{
                        document.getElementById('spinner').classList.add('hidden');
                        document.getElementById('error_message').innerHTML = 'Eligibility details are not found. Please try again by changing amount.';
                        document.getElementById('hc_error_popup').click();
                        return false;
                    }
                } 
            });
		}else{
            document.getElementById('spinner').classList.add('hidden');
			return false;
		}
	},
	getTotalValue: (arr) => {
        var total = 0;
        for(var i=0; i<arr.length; i++)
            total += arr[i].value;
        return total;
    },
    handleCoResidenceStatusSelection: ({target: {textContent, dataset: {value, cid}}}) => {
        if (!value) {
            return;
        }  
        // Store the selected city id a hidden field
        document.getElementById('hiddenCoResidenceStatus_'+cid).value = value;
        document.getElementById('select_residence_'+cid).innerHTML = '<span>' + textContent + '</span>';
        if(textContent == 'Indian'){
        	document.getElementById('coCountry_'+cid).classList.add('opacity_otp');
        	document.getElementById('coState_'+cid).classList.remove('opacity_otp');
        	document.getElementById('coCity_'+cid).classList.remove('opacity_otp');
        	HomeLoanCalculator.hideError('hiddenCountry_error_'+cid);
        	document.getElementById('hiddenCountry_'+cid).value = '';
        }else{
        	document.getElementById('coCountry_'+cid).classList.remove('opacity_otp');
        	document.getElementById('coState_'+cid).classList.add('opacity_otp');
        	document.getElementById('coCity_'+cid).classList.add('opacity_otp');
        	HomeLoanCalculator.hideError('hiddenState_error_'+cid);
        	HomeLoanCalculator.hideError('hiddenCoCityId_error_'+cid);
        	document.getElementById('hiddenState_'+cid).value = '';
        	document.getElementById('hiddenCoCityId_'+cid).value = '';
        }
    },
    handleCoOccupationSelection: ({target: {textContent, dataset: {value, cid}}}) => {
        if (!value) {
            return;
        }  
        // Store the selected city id a hidden field
        document.getElementById('hiddenCoOccupation_'+cid).value = value;
        document.getElementById('select_coOccupation_'+cid).innerHTML = '<span>' + textContent + '</span>';
        if(textContent == 'Employed'){
        	document.getElementById('coMonthlyIncome_'+cid).classList.remove('opacity_otp');
        	document.getElementById('co_retired_age_'+cid).classList.remove('opacity_otp');
        	document.getElementById('co_other_emi_'+cid).classList.remove('opacity_otp');
        }else{
        	document.getElementById('coMonthlyIncome_'+cid).classList.add('opacity_otp');
        	document.getElementById('co_retired_age_'+cid).classList.add('opacity_otp');
        	document.getElementById('co_other_emi_'+cid).classList.add('opacity_otp');
        	HomeLoanCalculator.hideError('co_gross_monthly_income_error_'+cid);
        	document.getElementById('co_gross_monthly_income_'+cid).value = '';
        	HomeLoanCalculator.hideError('coRetiredAge_error_'+cid);
        	document.getElementById('coRetiredAge_'+cid).value = '';
        }
    },
    addCoApplicants: () => {
    	let id = addApplicants();
    	document.getElementById('coResidenceStatus_'+id).addEventListener('click', HomeLoanCalculator.handleCoResidenceStatusSelection);
    	document.getElementById('coOccupation_'+id).addEventListener('click', HomeLoanCalculator.handleCoOccupationSelection);	
    	initialState.countyCodes = initialState.countryNames.map((country) => +country.code);
        initialState.stateCodes = initialState.states.map((states) => +states.code);
        // Render the countryNames as default
        HomeLoanCalculator.renderCountries(false, id);
        // Render the states as default
        HomeLoanCalculator.renderStates(false, id);

        // Attach the event handlers for country suggestions
        document.getElementById('countrySearch_'+id).addEventListener('input', HomeLoanCalculator.handleCountrySearch);
        document.getElementById('countrySearch_'+id).addEventListener('blur', HomeLoanCalculator.handleCounrtySearchFocusOut);
        //document.getElementById('resCitySearch').addEventListener('keydown', HomeLoanCalculator.handleCitySuggestionNavigation);
        document.getElementById('countrySearch_'+id+'Ul').addEventListener('click', HomeLoanCalculator.handleCountrySelection);

        // Attach the event handlers for state suggestions
        document.getElementById('stateSearch_'+id).addEventListener('input', HomeLoanCalculator.handleStateSearch);
        document.getElementById('stateSearch_'+id).addEventListener('blur', HomeLoanCalculator.handleStateSearchFocusOut);
        //document.getElementById('resCitySearch').addEventListener('keydown', HomeLoanCalculator.handleCitySuggestionNavigation);
        document.getElementById('stateSearch_'+id+'Ul').addEventListener('click', HomeLoanCalculator.handleStateSelection);

        // Attach the event handlers for city suggestions
        document.getElementById('coCitySearch_'+id).addEventListener('input', HomeLoanCalculator.handleCoCitySearch);
        document.getElementById('coCitySearch_'+id).addEventListener('blur', HomeLoanCalculator.handleCoCitySearchFocusOut);
        //document.getElementById('resCitySearch').addEventListener('keydown', HomeLoanCalculator.handleCitySuggestionNavigation);
        document.getElementById('coCitySearch_'+id+'Ul').addEventListener('click', HomeLoanCalculator.handleCoCitySelection);
    },
    renderCoCitySuggestions: (cities = [], inflate = true, id) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('coCitySearch_'+id).parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('coCitySearch_'+id+'Ul').innerHTML = cities.reduce((html, city) => html + `
            <li data-cid="${id}" data-value="${city.id}">${city.name}</li>
        `, '');
    },
    handleCoCitySearch: ({target: {value, id}}) => {
    	let searchId = id.split('_');
    	let cid = searchId[1];
        // Reset the selected city hidden field
        document.getElementById('hiddenCoCityId_'+cid).value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            //this.renderCoTopCities(true, cid);
        } else {
            // Search for the city by name based on the search string
            let coStateCode = document.getElementById('hiddenState_'+cid).value;
            const matchingCities = citiesByState.stateCities[coStateCode]
                .filter((city) => city.name.toLowerCase().startsWith(value));

            // Render the matching cities
            HomeLoanCalculator.renderCoCitySuggestions(matchingCities, true, cid);
        }
    },
    handleCoCitySearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('coCitySearch_0').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handleCoCitySelection: ({target: {textContent, dataset: {value, cid}}}) => {
        if (!value) {
            return;
        }
        // Store the selected city id a hidden field
        document.getElementById('hiddenCoCityId_'+cid).value = value;
        document.getElementById('coCitySearch_'+cid).value = textContent;
        document.getElementById('coCitySearch_'+cid).focus();
    },
    renderStates: (inflate = true, id) => {
        HomeLoanCalculator.renderStateSuggestions(countryAndState.data.topStates, inflate, id);
    },
    renderStateSuggestions: (topStates = [], inflate = true, id) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('stateSearch_'+id).parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('stateSearch_'+id+'Ul').innerHTML = topStates.reduce((html, states) => html + `
            <li data-cid="${id}" data-value="${states.code}">${(states.name).charAt(0).toUpperCase() + (states.name).slice(1).toLowerCase()}</li>
        `, '');
    },
    handleStateSearch: ({target: {value, id}}) => {
        let searchId = id.split('_');
        let cid = searchId[1];
        // Reset the selected city hidden field
        document.getElementById('hiddenState_'+cid).value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            this.renderStates(true, cid);
        } else {
            // Search for the state by name based on the search string
            const matchingStates = initialState.states
                .filter((states) => states.name.toLowerCase().startsWith(value));

            // Render the matching states
            HomeLoanCalculator.renderStateSuggestions(matchingStates, true, cid);
        }
    },
    handleStateSearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('stateSearch_0').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handleStateSelection: ({target: {textContent, dataset: {value, cid}}}) => {
        if (!value) {
            return;
        }
        // Store the selected state id a hidden field
        document.getElementById('hiddenState_'+cid).value = value;
        document.getElementById('stateSearch_'+cid).value = textContent;
        document.getElementById('stateSearch_'+cid).focus();
        HomeLoanCalculator.renderCoCitySuggestions(citiesByState.stateCities[value], true, cid);
    },
    renderCountries: (inflate = true, id) => {
        HomeLoanCalculator.renderCountrySuggestions(countryAndState.data.topCountries, inflate, id);
    },
    renderCountrySuggestions: (countryNames = [], inflate = true, id) =>{
        // Inflate the dropdown
        if (inflate) {
            document.getElementById('countrySearch_'+id).parentElement.classList.add('open');
        }
        HomeLoanCalculator.clearSearchItems();
        document.getElementById('countrySearch_'+id+'Ul').innerHTML = countryNames.reduce((html, country) => html + `
            <li data-cid="${id}" data-value="${country.code}">${(country.name).toLowerCase()}</li>
        `, '');
    },
    handleCountrySearch: ({target: {value, id}}) => {
    	let searchId = id.split('_');
    	let cid = searchId[1];
        // Reset the selected city hidden field
        document.getElementById('hiddenCountry_'+cid).value = '';

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();

        // Render the top suggestions if the search string is empty
        if (!value) {
            this.renderCountries(true, cid);
        } else {
            // Search for the city by name based on the search string
            const matchingCountries = initialState.countryNames
                .filter((country) => country.name.toLowerCase().startsWith(value));

            // Render the matching cities
            HomeLoanCalculator.renderCountrySuggestions(matchingCountries, true, cid);
        }
    },
    handleCounrtySearchFocusOut: (ev) => {
        if (ev.relatedTarget) {
            document.getElementById('countrySearch_0').parentElement.classList.remove('open');
        }
        HomeLoanCalculator.clearSearchItems();
    },
    handleCountrySelection: ({target: {textContent, dataset: {value, cid}}}) => {
        if (!value) {
            return;
        }
        // Store the selected country id a hidden field
        document.getElementById('hiddenCountry_'+cid).value = value;
        document.getElementById('countrySearch_'+cid).value = textContent;
        document.getElementById('countrySearch_'+cid).focus();
    },
    removeCoApplicants: (id) => {
    	removeApplicants(id);
    },
    homeloanPrepayment: () => {
        PrepaymentCalc.prepaymentCalc();
    },
    validatePrepaymentLoanTenure: () => {
        PrepaymentCalc.isPrePaymentLoanTenureValid();
    },
    resetPrepaymentFormData: () => {
        PrepaymentCalc.resetPrepaymentForm();
    },
    homeloanReprepayment: () => {
        RepaymentCalc.repaymentCalc();
    },
    validateRepaymentLoanTenure: () => {
        RepaymentCalc.isRePaymentLoanTenureValid();
    },
    resetRepaymentFormData: () => {
        RepaymentCalc.resetRepaymentForm();
    },
    homeloanRateChange: () => {
        RateChangeCalc.rateChangeCalc();
    },
    validateRateChangeLoanTenure: () => {
        RateChangeCalc.isRateChangeTenureValid();
    },
    convertRateChangeDate: (id) => {
        RateChangeCalc.convertDate(id);
    },
    resetRateChangeFormData: () => {
        RateChangeCalc.resetRateChangeForm();
    },
    homeloanTransferLoan: () => {
        LoanTransferCalc.loanTransferCalc();
    },
    validateLoanTransferLoanTenure: () => {
        LoanTransferCalc.isLoanTransferTenureValid();
    },
    validateLoanTransferLoanTenureNew: () => {
        LoanTransferCalc.isLoanTransferTenureNewValid();
    },
    resetTransferLoanFormData: () => {
        LoanTransferCalc.resetTransferLoanForm();
    },
    calculateEmi: () => {
        EmiCalc.checkEmi();
    },
    validateEmiLoanTenure: () => {
        EmiCalc.isEmiLoanTenureValid();
    },
    resetEmicalcFormData: () => {
        EmiCalc.resetEmicalcForm();
    },
    convertPercentage: (id) => {
        HomeLoanCalculator.isNemericPercentageValue(id);
        let percentage = document.getElementById(id).value;
        percentage = percentage.replace(/%/g, '');
        percentage = percentage.trim();
        let percent = percentage.split('.');
        let val = percent[0];
        let isPercentage = HomeLoanCalculator.isValidPercentage(parseInt(val), id);
        if(isPercentage){
            let data = HomeLoanCalculator.inWordsOnly(percent[0]);
            let pointText = '';
            if(percent.length > 1){
                let decimalValue = percent[1];
                val += '.'+ decimalValue;

                for (var i = 0; i < decimalValue.length; i++) {
                    pointText += HomeLoanCalculator.inWordsOnly(decimalValue[i]);
                }
                data += ' point '+pointText;
            }
            document.getElementById(id).value = val;
            document.getElementById(id+'_price').classList.remove('hide');
            document.getElementById(id+'_price').innerHTML = data;
        }else {
            document.getElementById(id).value = '';
            document.getElementById(id+'_price').classList.add('hide');
            document.getElementById(id+'_price').innerHTML = '';
        }
        
    },
    selectOption: (ev, id) => {
        homeloancalc.elSuggestions = document.getElementById(id+'Ul').children;
        const totalSuggestions = document.getElementById(id+'Ul').childElementCount;
        if (homeloancalc.elSuggestNavLast) {
            homeloancalc.elSuggestNavLast.classList.remove('active');
        }
        // Update the cursor
        if (40 === ev.keyCode && homeloancalc.suggestNavIdx < (totalSuggestions - 1)) {
            homeloancalc.suggestNavIdx += 1;
            homeloancalc.elSuggestNavLast = homeloancalc.elSuggestions.item(homeloancalc.suggestNavIdx);
            homeloancalc.elSuggestNavLast.classList.add('active');
        } else if (38 === ev.keyCode && homeloancalc.suggestNavIdx > 0) {
            homeloancalc.suggestNavIdx -= 1;
            homeloancalc.elSuggestNavLast = homeloancalc.elSuggestions.item(homeloancalc.suggestNavIdx);
            homeloancalc.elSuggestNavLast.classList.add('active');
        } else if (13 === ev.keyCode) {
            ev.preventDefault();
            homeloancalc.elSuggestions.item(homeloancalc.suggestNavIdx).click();
            HomeLoanCalculator.clearSearchItems();
        }else if(40 === ev.keyCode || (38 === ev.keyCode && homeloancalc.suggestNavIdx != -1)){
            ev.preventDefault();
            homeloancalc.elSuggestNavLast = homeloancalc.elSuggestions.item(homeloancalc.suggestNavIdx);
            homeloancalc.elSuggestNavLast.classList.add('active');
        }else if(37 === ev.keyCode || 39 === ev.keyCode && (homeloancalc.suggestNavIdx > 0)){
            HomeLoanCalculator.clearSearchItems();
        }
    },
    clearSearchItems: () =>{
        if (homeloancalc.elSuggestNavLast) {
            homeloancalc.elSuggestNavLast.classList.remove('active');
        }
        homeloancalc.suggestNavIdx = -1;
        homeloancalc.elSuggestNavLast = null;
        homeloancalc.elSuggestions = null;
    },
	validateEligibilityForm: () => {
		let isFormValid = false;
		//Name check..
		if(HomeLoanCalculator.isNameValid() && HomeLoanCalculator.isEmailValid() ) {
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Email check
		if(HomeLoanCalculator.isEmailValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Mobile check
		if(HomeLoanCalculator.isMobileValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//city check
		if(HomeLoanCalculator.isCityValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		if(HomeLoanCalculator.isStateValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		if(HomeLoanCalculator.isCountryValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Loan type check
		if(HomeLoanCalculator.isLoanTypeValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Age check
		if(HomeLoanCalculator.isAgeValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Retired age check
		if(HomeLoanCalculator.isRetireAgeValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Occupation check
		if(HomeLoanCalculator.isOccupationValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Gross monthly income check
		if(HomeLoanCalculator.isGrossMonthlyIncomeValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Property cost check
		if(HomeLoanCalculator.isPropertyCostValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//Loan Amount check
		if(HomeLoanCalculator.isLoanAmountValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		//property located city check
		if(HomeLoanCalculator.isPropLocatedCityValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
        //property located city check
		if(HomeLoanCalculator.isPropLocatedStateValid()){
			isFormValid = true;
		} else{
			isFormValid = false;
		}
		return isFormValid;

	},
	isNameValid() {
		let username = document.getElementById('username').value;
		let regex = /^[A-Za-z0-9 ]+$/i;
		if(username.match(regex) && username !='') {
			HomeLoanCalculator.hideError('username_error');
			homeloancalc.inputValues.username = username;
			return true;
		} else {
			let msg = "Please enter valid name";
			HomeLoanCalculator.showError('username_error', msg);
			return false;
		}
	},
	isEmailValid() {
		let useremail = document.getElementById('useremail').value;
        let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(useremail.match(regex) && useremail !='') {
			HomeLoanCalculator.hideError('useremail_error');
			homeloancalc.inputValues.useremail = useremail;
			return true;
		} else {
			let msg = "Please enter valid email";
			HomeLoanCalculator.showError('useremail_error', msg);
			return false;
		}
	},
	isMobileValid() {
		let usermobile = document.getElementById('usermobile').value;
		let regex = /^[0-9 ]+$/i;
		if(usermobile.match(regex) && usermobile !='' && usermobile.length == 10) {
			HomeLoanCalculator.hideError('usermobile_error');
			homeloancalc.inputValues.usermobile = usermobile;
			return true;
		} else {
			let msg = "Please enter valid phone number";
			HomeLoanCalculator.showError('usermobile_error', msg);
			return false;
		}
	},
	isCityValid: () => {
		if (document.getElementById('indian').checked) {
		  	let hiddenResCityId = document.getElementById('hiddenResCityId').value;
		  	if(hiddenResCityId !='') {
				HomeLoanCalculator.hideError('hiddenResCityId_error');
				homeloancalc.inputValues.hiddenResCityId = hiddenResCityId;
				return true;
			} else {
				let msg = "Please Select city";
				HomeLoanCalculator.showError('hiddenResCityId_error', msg);
				return false;
			}
		}
	},
	isStateValid: () => {
		if (document.getElementById('indian').checked) {
		  	let hiddenResStateId = document.getElementById('hiddenResStateId').value;
		  	if(hiddenResStateId !='') {
				HomeLoanCalculator.hideError('hiddenResStateId_error');
				homeloancalc.inputValues.hiddenResStateId = hiddenResStateId;
				return true;
			} else {
				let msg = "Please Select State";
				HomeLoanCalculator.showError('hiddenResStateId_error', msg);
				return false;
			}
		}
	},
	isCountryValid: () => {
		if (document.getElementById('nri').checked) {
		  	let hiddenResCountryId = document.getElementById('hiddenResCountryId').value;
		  	if(hiddenResCountryId !='') {
				HomeLoanCalculator.hideError('hiddenResCountryId_error');
				homeloancalc.inputValues.hiddenResCountryId = hiddenResCountryId;
				return true;
			} else {
				let msg = "Please Select Country";
				HomeLoanCalculator.showError('hiddenResCountryId_error', msg);
				return false;
			}
		}else {
            homeloancalc.inputValues.hiddenResCountryId = 'INDIA';
        }
	},
	isPropLocatedCityValid: () => {
		let loanType = document.getElementById('hiddenLoantype').value;
        let shortlist = document.getElementById('shortlisted').checked;
		if (loanType == 'HOU' && shortlist == true) {
            let hiddenPropLocatedCityId = document.getElementById('hiddenPropLocatedCityId').value;
		  	if(hiddenPropLocatedCityId !='') {
                HomeLoanCalculator.hideError('hiddenPropLocatedCityId_error');
				homeloancalc.inputValues.hiddenPropLocatedCityId = hiddenPropLocatedCityId;
				return true;
			} else {
				let msg = "Please Select property located city";
				HomeLoanCalculator.showError('hiddenPropLocatedCityId_error', msg);
				return false;
			}
		}else {
            return true;
        }
	},
	isPropLocatedStateValid: () => {
		let loanType = document.getElementById('hiddenLoantype').value;
		let shortlist = document.getElementById('shortlisted').checked;
		if (loanType == 'HOU' && shortlist == true) {
		  	let hiddenPropLocatedStateId = document.getElementById('hiddenPropLocatedStateId').value;
		  	if(hiddenPropLocatedStateId !='') {
				HomeLoanCalculator.hideError('hiddenPropLocatedStateId_error');
				homeloancalc.inputValues.hiddenPropLocatedState = hiddenPropLocatedStateId;
				return true;
			} else {
				let msg = "Please Select property located State";
				HomeLoanCalculator.showError('hiddenPropLocatedStateId_error', msg);
				return false;
			}
		}else {
            return true;
        }
	},
	isAgeValid() {
		let user_age = document.getElementById('user_age').value;
		let regex = /^[0-9 ]+$/i;
		if(user_age.match(regex) && user_age !='') {
			HomeLoanCalculator.hideError('user_age_error');
			homeloancalc.inputValues.user_age = user_age;
			return true;
		} else {
			let msg = "Please enter valid numeric age";
			HomeLoanCalculator.showError('user_age_error', msg);
			return false;
		}
	},
    isNemericValue(id) {
        let user_age = document.getElementById(id).value;
        let regex = /^[0-9 ]+$/i;
        if(user_age.match(regex) && user_age !='') {
            HomeLoanCalculator.hideError(id+'_error');
            return true;
        } else {
            document.getElementById(id).value = '';
            let msg = "Please Enter Valid Numeric Values";
            HomeLoanCalculator.showError(id+'_error', msg);
            return false;
        }
    },
    isNemericPriceValue(id) {
        let user_age = document.getElementById(id).value;
        let regex = /^[0-9, ]+$/i;
        if(user_age.match(regex) && user_age !='') {
            HomeLoanCalculator.hideError(id+'_error');
            return true;
        } else {
            document.getElementById(id).value = '';
            let msg = "Please Enter Valid Numeric Values";
            HomeLoanCalculator.showError(id+'_error', msg);
            return false;
        }
    },
    isNemericPercentageValue(id) {
        let user_age = document.getElementById(id).value;
        user_age = user_age.replace(/%/g, '');
        user_age = user_age.trim();
        let regex = /^[0-9\. ]+$/i;
        if(user_age.match(regex) && user_age !='') {
            HomeLoanCalculator.hideError(id+'_error');
            return true;
        } else {
            document.getElementById(id).value = '';
            let msg = "Please Enter Valid Numeric Values";
            HomeLoanCalculator.showError(id+'_error', msg);
            return false;
        }
    },
    isValidPercentage(val, id) {
        if(val <= 99) {
            HomeLoanCalculator.hideError(id+'_error');
            return true;
        } else {
            let msg = "Please Enter Valid Percentage";
            HomeLoanCalculator.showError(id+'_error', msg);
            return false;
        }
    },
    isNemericCoPriceValue(id,val) {
        let price = document.getElementById(id+val).value;
        let regex = /^[0-9, ]+$/i;
        if(price.match(regex) && price !='') {
            HomeLoanCalculator.hideError(id+'error_'+val);
            return true;
        } else {
            document.getElementById(id+val).value = '';
            let msg = "Please Enter Valid Numeric Values";
            HomeLoanCalculator.showError(id+'error_'+val, msg);
            return false;
        }
    },
    isNemericCoValue(id,val) {
       let user_age = document.getElementById(id+val).value;
        let regex = /^[0-9 ]+$/i;
        if(user_age.match(regex) && user_age !='') {
            HomeLoanCalculator.hideError(id+'error_'+val);
            return true;
        } else {
            document.getElementById(id+val).value = '';
            let msg = "Please Enter Valid Numeric Values";
            HomeLoanCalculator.showError(id+'error_'+val, msg);
            return false;
        }
    },
	isOccupationValid() {
		let hiddenOccupation = document.getElementById('hiddenOccupation').value;
		if(hiddenOccupation !='') {
			HomeLoanCalculator.hideError('hiddenOccupation_error');
			homeloancalc.inputValues.hiddenOccupation = hiddenOccupation;
			return true;
		} else {
			let msg = "Please Select Occupation";
			HomeLoanCalculator.showError('hiddenOccupation_error', msg);
			return false;
		}
	},
	isRetireAgeValid() {
		let occupation = document.getElementById('hiddenOccupation').value;
		if(occupation == 'E'){
			let retired_age = document.getElementById('retired_age').value;
			let regex = /^[0-9 ]+$/i;
			if(retired_age.match(regex) && retired_age !='') {
				HomeLoanCalculator.hideError('retired_age_error');
				homeloancalc.inputValues.retired_age = retired_age;
				return true;
			} else {
				let msg = "Please enter valid numeric retired age";
				HomeLoanCalculator.showError('retired_age_error', msg);
				return false;
			}
		}else{
			return true
		}
		
	},
	isGrossMonthlyIncomeValid() {
		let occupation = document.getElementById('hiddenOccupation').value;
		if(occupation == 'E'){
			let gross_monthly_income = document.getElementById('gross_monthly_income').value;
            gross_monthly_income = gross_monthly_income.replace(/,/g, '');
			let regex = /^[0-9,]+$/i;
			if(gross_monthly_income.match(regex) && gross_monthly_income !='') {
				HomeLoanCalculator.hideError('gross_monthly_income_error');
				homeloancalc.inputValues.gross_monthly_income = gross_monthly_income;
				return true;
			} else {
				let msg = "Please enter gross mothly income";
				HomeLoanCalculator.showError('gross_monthly_income_error', msg);
				return false;
			}
		}else {
			return true;
		}
	},
	isLoanTypeValid: () => {
	  	let hiddenLoantype = document.getElementById('hiddenLoantype').value;
	  	if(hiddenLoantype !='') {
			HomeLoanCalculator.hideError('hiddenLoantype_error');
			homeloancalc.inputValues.hiddenLoantype = hiddenLoantype;
			return true;
		} else {
			let msg = "Please select type of loan";
			HomeLoanCalculator.showError('hiddenLoantype_error', msg);
			return false;
		}
	},
	isPropertyCostValid() {
		let property_cost = document.getElementById('property_cost').value;
        property_cost = property_cost.replace(/,/g, '');
		let regex = /^[0-9, ]+$/i;
		if(property_cost.match(regex) && property_cost !='') {
			HomeLoanCalculator.hideError('property_cost_error');
			homeloancalc.inputValues.property_cost = property_cost.replace(/,/g, '');
			return true;
		} else {
			let msg = "Please enter property cost";
			HomeLoanCalculator.showError('property_cost_error', msg);
			return false;
		}
	},
	isLoanAmountValid() {
		let loan_amount = document.getElementById('loan_amount').value;
        loan_amount = loan_amount.replace(/,/g, '');
		let regex = /^[0-9, ]+$/i;
		if(loan_amount.match(regex) && loan_amount !='') {
			HomeLoanCalculator.hideError('loan_amount_error');
			homeloancalc.inputValues.loan_amount = loan_amount.replace(/,/g, '');
			return true;
		} else {
			let msg = "Please enter loan amount";
			HomeLoanCalculator.showError('loan_amount_error', msg);
			return false;
		}
	},
	showError: (elem, msg) => {
		let element = document.getElementById(elem);
		if(element && element.classList.contains('hide')) {
			element.classList.remove("hide");
			element.innerHTML = msg;
		}
	},
	hideError: (elem) => {
		let element = document.getElementById(elem);
		if(element && !element.classList.contains('hide')) {
			element.classList.add("hide");
		}
	}

}




document.addEventListener("DOMContentLoaded", function() { 
	HomeLoanCalculator.init();
});
